package com.arena_web.ui.theme

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color

/**
 * CSS-variable-backed theme values. Prefer these over AppColors for any
 * surface/text/border/shadow that must differ between dark and light —
 * the tokens are defined in AppTheme.kt (`:root` = dark,
 * `[data-theme=light]` = light) and flip instantly when ThemeController
 * toggles the attribute.
 *
 * Raw string constants (`*_V`) are for `styleModifier { property(...) }`
 * and string-built CSS; the [CSSColorValue] vals are for typed modifiers
 * (`.color()`, `.backgroundColor()` — use the compose-web overload, the
 * kobweb-Color overload cannot carry a var()).
 */
object ThemeVars {
    const val BG_V = "var(--arena-bg)"
    const val BG_IMAGE_V = "var(--arena-bg-image)"
    const val GLASS_V = "var(--arena-glass)"
    const val GLASS_STRONG_V = "var(--arena-glass-strong)"
    const val SURFACE_V = "var(--arena-surface)"
    const val SURFACE_VARIANT_V = "var(--arena-surface-variant)"
    const val SURFACE_POPUP_V = "var(--arena-surface-popup)"
    const val TEXT_1_V = "var(--arena-text-1)"
    const val TEXT_2_V = "var(--arena-text-2)"
    const val TEXT_3_V = "var(--arena-text-3)"
    const val TEXT_MUTED_V = "var(--arena-text-muted)"
    const val TEXT_NAV_INACTIVE_V = "var(--arena-text-nav-inactive)"
    const val BORDER_TOP_V = "var(--arena-border-top)"
    const val BORDER_BOTTOM_V = "var(--arena-border-bottom)"
    const val BORDER_V = "var(--arena-border)"
    const val SHADOW_CARD_V = "var(--arena-shadow-card)"
    const val GLOW_CTA_V = "var(--arena-glow-cta)"
    const val OVERLAY_V = "var(--arena-overlay)"
    const val PLACEHOLDER_V = "var(--arena-placeholder)"
    const val MAP_BG_V = "var(--arena-map-bg)"
    const val ICON_FILTER_V = "var(--arena-icon-filter)"

    val Bg: CSSColorValue = Color(BG_V)
    val Glass: CSSColorValue = Color(GLASS_V)
    val GlassStrong: CSSColorValue = Color(GLASS_STRONG_V)
    val Surface: CSSColorValue = Color(SURFACE_V)
    val SurfaceVariant: CSSColorValue = Color(SURFACE_VARIANT_V)
    val SurfacePopup: CSSColorValue = Color(SURFACE_POPUP_V)
    val Text1: CSSColorValue = Color(TEXT_1_V)
    val Text2: CSSColorValue = Color(TEXT_2_V)
    val Text3: CSSColorValue = Color(TEXT_3_V)
    val TextMuted: CSSColorValue = Color(TEXT_MUTED_V)
    val TextNavInactive: CSSColorValue = Color(TEXT_NAV_INACTIVE_V)
    val Border: CSSColorValue = Color(BORDER_V)
    val Overlay: CSSColorValue = Color(OVERLAY_V)
}
